import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/recurso/importer/recursoImporterSelectors';
import RecursoService from 'src/modules/recurso/recursoService';
import fields from 'src/modules/recurso/importer/recursoImporterFields';
import { i18n } from 'src/i18n';

const recursoImporterActions = importerActions(
  'RECURSO_IMPORTER',
  selectors,
  RecursoService.import,
  fields,
  i18n('entities.recurso.importer.fileName'),
);

export default recursoImporterActions;